import { Button, Form, Input, Modal, Select } from "antd";
import { React } from "react";

export default function AddAccessGroupTag({ props }) {
  return (
    <>
      <div className={"pb-3 pr-2 wfit"}>
        <Button type="primary" onClick={props.toggleVisibilityAddTag}>
          Add Tag
        </Button>

        <Modal
          visible={props.visibilityAddTag}
          title="Add Tag"
          onOk={props.toggleVisibilityAddTag}
          onCancel={props.toggleVisibilityAddTag}
          footer={[
            <Button key="back" onClick={props.toggleVisibilityAddTag}>
              Return
            </Button>,
            <Button
              type="primary"
              key="submit"
              className={"btn btn-success"}
              loading={props.loading}
              onClick={props.createTag}
            >
              Submit
            </Button>,
          ]}
        >
          <Form
            name="add_tag"
            className="add-tag-form"
            initialValues={{ remember: true }}
            onFinish={props.createTag}
          >
            <Form.Item>
              <span> New Tag Name</span>
              <Input
                value={props.taggingName}
                onChange={(e) => props.setTaggingName(e.target.value)}
                placeholder="Input Tagging Name"
              ></Input>
            </Form.Item>
            <Form.Item>
              <span> Tagging Name</span>
              <Select
                showSearch
                value={props.taggingID || null}
                onChange={(e) => props.setTaggingID(e)}
                size="default"
                placeholder={"Select Tagging Name"}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                className="w-100percent ant-input mw-150"
              >
                {props.taggings?.map((mode, index) => (
                  <Option value={mode.id} key={index}>
                    {mode.tagging_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  );
}
